
export default {
  // 导航栏
  navbar: {
    title: 'title',
    languageSwitch: 'languageSwitch',
    theme: 'theme'
  },
  home: {
    welcome: 'Welcome to',
    chargingPlatform: 'bull charging Platform',
    currentLanguage: 'current Language',
    currentCompany: 'current Company',
    changePassword: 'change Password',
    logOut: 'log Out'
  },
  commonly: {
    yes: 'yes',
    not: 'no',
    inputContent: 'please enter the content',
    element: 'element',
    determine: 'determine',
    cancel: 'cancel',
    noData: 'no Data'
  },
  elTable: {
    serialNumber: 'serial Number',
    userAccount: 'user Account',
    userInformation: 'user Information',
    userName: 'user Name',
    carNumber: 'car Number',
    phoneNumber: 'phone Number',
    state: 'state',
    oneNoOvercharge: 'One No Overcharge',
    operation: 'operation'
  },
  enterpriseUser: {
    setThreshold: 'set Threshold',
    carInformation: 'car Information',
    carNumber: 'car Number',
    allPeople: 'all People',
    carType: 'car Type',
    brandModel: 'brand Model',
    carCode: 'car Distinguish Code'
  },
  route: {
    userManagement: 'user Management',
    enterpriseUsers: 'enterprise Users',
    editEnterpriseUsers: 'edit Enterprise Users',
    addEnterpriseUsers: 'add Enterprise Users',
    userDetails: 'user Details',
    UserWallet: 'User Wallet',
    isenterpriseUser: 'isenterprise User',
    addIsenterpriseUser: 'add Isenterprise User',
    editIsenterpriseUser: 'edit Isenterprise User',
    isenterpriseUserDetails: 'isenterprise User Details',
    administrators: 'administrators',
    addAdministrators: 'add Administrators',
    editAdministrators: 'edit Administrators',
    roleManagement: 'role Uanagement',
    addRole: 'add Role',
    editRole: 'edit Role',
    systemManagement: 'system Management',
    electricEquipmentManagement: 'electric Equipment Management',
    powerStationManagement: 'power Station Management',
    addPowerStation: 'add Power Station',
    editPowerStation: 'edit Power Station',
    powerStationDetails: 'power Station Details',
    electricPileManagement: 'electric Pile Management',
    addElectricPile: 'add Electric Pile',
    editChargingGun: 'edit Charging Gun',
    chargingGunDetails: 'charging Gun Details',
    interconnectedPowerStation: 'interconnected Power Station',
    whiteList: 'white List',
    addWhiteList: 'add White List',
    editWhiteList: 'edit White List',
    whiteListDetails: 'white List Details',
    valueAddedServices: 'value Added Services',
    flowScheme: 'flow Scheme',
    addFlowScheme: 'add Flow Scheme',
    flowSchemeDetails: 'flow Scheme Details',
    flowSchemeEdit: 'flow Scheme Edit',
    entranceScheme: 'entrance Scheme',
    addEntranceScheme: 'add Entrance cheme',
    entranceSchemeDetails: 'entrance Scheme Details',
    entranceSchemeEdit: 'entrance Scheme Edit',
    operatorManagement: 'operator Management',
    operatorWallet: 'operator Wallet',
    newlyAdded: 'newly Added',
    modify: 'modify',
    details: 'details',
    orderManagement: 'order Management',
    userRealTimeOrder: 'user Real Time Order',
    realTimeOrderDetails: 'real Time Order Details',
    orderStationManagement: 'order Station Management',
    userHistoryOrder: 'user History Order',
    historyOrderDetails: 'history Order Details',
    stationHistoryOrder: 'station History Order',
    pendingOrders: 'pending Orders',
    handle: 'handle',
    alarmCenter: 'alarm Center',
    pileSafetyAlarm: 'pile Safety Alarm',
    pileSafetyAlarmDetails: 'pile Safety Alarm Details',
    pileOfflineAlarmDetails: 'pile Offline Alarm Details',
    pileFaultAlarmDetails: 'pile Fault Alarm Details',
    vehicleAlarm: 'vehicle Alarm',
    vehicleAlarmDetails: 'vehicle Alarm Details',
    negativeValueAlarm: 'negative Value Alarm',
    stationAlarmSetting: 'station Alarm Setting',
    addAlarmSetting: 'add Alarm etting',
    editAlarmSetting: 'edit Alarm Setting',
    alarmSettingDetails: 'alarm Setting Details',
    groupManagement: 'group Management',
    alarmRecord: 'alarm Record',
    statisticalCenter: 'statistical Center',
    stationTotal: 'station Total',
    pileTotal: 'pile Total',
    organTotal: 'organ Total',
    userTotal: 'user Total',
    timeUserTotal: 'timeUser Total',
    timeStationTotal: 'time Station Total',
    notificationManagement: 'notification Management',
    messageSending: 'message Sending',
    smsSettings: 'sms Settings',
    advertisingManagement: 'advertising Management',
    powerStationActivities: 'power Station Activities',
    coupon: 'coupon',
    preferentialScheme: 'preferential Scheme',
    couponManagement: 'coupon Management',
    taskDetails: 'task Details',
    manualRelease: 'manual Release',
    couponIssuance: 'coupon Issuance',
    labelManagement: 'label Management',
    addTag: 'add Tag',
    modifyUserTag: 'modify User Tag',
    modifySystemTag: 'modify System Tag',
    addPreferentialScheme: 'add Preferential Scheme',
    preferentialSchemeDetails: 'preferential Scheme Details',
    editPreferentialScheme: 'edit Preferential Scheme',
    financialManagement: 'financial Management',
    financialOverview: 'financial Overview',
    financialDetails: 'financial Details',
    moneyCount: 'profit Distribution Summary',
    earnMoney: 'view Profit Sharing Amount',
    profitRecord: 'Profit Records',
    profitSettle: 'Profit Record Settlement',
    moneyDetail: 'profit Distribution Details',
    payDetail: 'order Detail',
    orderDetail: 'order Detail',
    ticketManagement: 'ticket Management',
    ticketEdit: 'ticket Edit',
    invoicingApproval: 'invoicing Approval',
    invoicingDetails: 'invoicing Details',
    siteComment: 'site Comment',
    chargingCardManagement: 'charging Card Management',
    chargingCardEdit: 'charging Card Edit',
    systemSettings: 'system Settings',
    gateManagement: 'gate Management',
    logView: 'log View',
    logManagement: 'electric Pile Message Management',
    logOperation: 'Operation log',
    interconnectionKey: 'interconnection Key',
    appManagement: 'edition Management',
    userActivity: 'user Activity',
    registrationActivities: 'registration Activities',
    registrationAdd: 'registration Add',
    rechargeActivities: 'recharge Activities',
    rechargeAdd: 'recharge Add',
    singleConsumption: 'single Consumption',
    singleAdd: 'single Add',
    firstCharge: 'first Charge Activity',
    firstAdd: 'add First Charge Activity',
    groupCharge: 'group Charging Activities',
    groupAdd: 'add Group Charging Activities',
    scanGet: 'code Scanning And Coupon Collection',
    scanAdd: 'add Code Scanning And Coupon Collection',
    cumulativeConsumption: 'cumulative Consumption',
    cumulativeAdd: 'cumulative Add',
    shareActivity: 'share Activity',
    shareAdd: 'share Add',
    shareDetail: 'share Detail',
    pileUse: 'pile Use',
    couponIssuanceDetails: 'Coupon Issuance Details',
    pileFault: 'pile Fault',
    pileFaultList: 'Brand list of electric pile',
    stationBrand: 'station Brand',
    stationModel: 'station Model',
    monitorView: 'monitor View',
    authorityManagement: 'authority Management',
    stationManagement: 'station Management',
    interProgramme: 'inter Programme',
    equityManagement: 'equity Management',
    userLevel: 'user Level',
    addUserLevel: 'add User Level',
    userEquity: 'user Equity',
    addUserEquity: 'add User Equity',
    reviseUserEquity: 'revise User Equity',
    occupyDetail: 'occupation Details',
    firmwareVersion: 'firmware Version Management',
    versionAdd: 'add Firmware Version',
    versionModify: 'revise Firmware Version',
    subsidyManagement: 'Subsidy management',
    addSubsidy: 'New subsidies',
    modifySubsidy: 'Modify subsidy',
    detailSubsidy: 'Subsidy details'
  }
}



// WEBPACK FOOTER //
// ./src/utils/lang/en.js